import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { AppErrors, ConflictError, NotFoundError } from '@fitness-force/errors';

import { environment } from 'apps/ff-frontend/src/environments/environment';
import { throwError, Observable, pipe } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { OpportunityBoardType } from '@fitness-force/enum';
import { CreateResponse } from '@fitness-force/models';

@Injectable({
  providedIn: 'root',
})
export class TrialService {
  constructor(private http: HttpClient, private router: Router) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  getTrials(tenantId: number) {
    return this.http
      .get(
        `${environment.BASE_URL}/tenants/${tenantId}/trial_mst`,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


  updateTrial(tenantId: number, trialId: number, data: any) {
    return this.http
      .put(
        `${environment.BASE_URL}/tenants/${tenantId}/trial_mst/${trialId}`,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }




  createTrial(tenantId: number, data: any) {
    return this.http
      .post(
        `${environment.BASE_URL}/tenants/${tenantId}/trial_mst`,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  deleteTrial(tenantId: number, trialId: number) {
    return this.http
      .delete(
        `${environment.BASE_URL}/tenants/${tenantId}/trial_mst/${trialId}`
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


  markActive(tenantId: number, trialId: number) {
    return this.http
      .post(
        `${environment.BASE_URL}/tenants/${tenantId}/trial_mst/${trialId}/mark_as_active`,
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markInActive(tenantId: number, trialId: number) {
    return this.http
      .post(
        `${environment.BASE_URL}/tenants/${tenantId}/trial_mst/${trialId}/mark_as_inactive`,
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getClientTrials(tenantId: number, allparams: any) {
    let parsedParams = new HttpParams()
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });
    return this.http
      .get(
        `${environment.BASE_URL}/tenants/${tenantId}/trials`,
        { headers: this.httpOptions.headers, params: parsedParams }
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


}
